const FAUCET_KEY = 'mockFaucet';

export const mockStorage = {
  readFaucet(): boolean {
    return localStorage.getItem(FAUCET_KEY) === 'true';
  },
  updateFaucet(flag: boolean) {
    localStorage.setItem(FAUCET_KEY, String(flag));
  },
};
